import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";
export const GetUserProfileDetails = async () => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.get(
			`${CONFIG.STUDENTURL}/api/v2/student/profile`,
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		console.log(error);
		return [];
	}
};
